if (module.hot) {
  module.hot.accept();
}

// import { initCursor } from "./cursor";
import { initNav } from "./nav";
import { initHoverReveal } from "./gallery";

function init() {
  // initCursor();
  initNav();
  initHoverReveal();
}

init();
